export class Review {

    private cpaKey: string;
    private reviewDate: number;
    private discountKey: string;
    private shipmentCount: number | null;
    private revenueCount: number | null;
    private discountAmount: number | null;
    private discountPercent: number | null;
    private topThresholdReached: string | null;
    private compareToLast: string | null;
    private payerCountry: string;
    private measurementPeriod: number | null;
    private discountPeriod: number | null;
    private countryEndSeq: number | null;
    private discountPid: string | null;
    private discountProductGroup: string;
    private nonReviewReason: string | null;
    private reviewDtm: number | null;
    private measurementStartDate: number | null;
    private measurementEndDate: number | null;
    private discountStartDate: number | null;
    private discountEndDate: number | null;
    private currencyCode: string | null;

    constructor(raw: any) {
        if (raw) {
            this.setCpaKey(raw.CPA_KEY);
            this.setReviewDate(raw.REVIEW_DATE);
            this.setDiscountKey(raw.DISCOUNT_KEY);
            this.setShipmentCount(raw.SHIPMENT_COUNT);
            this.setRevenueCount(raw.REVENUE_COUNT);
            this.setDiscountAmount(raw.DISCOUNT_AMOUNT);
            this.setDiscountPercent(raw.DISCOUNT_PERCENT);
            this.setTopThresholdReached(raw.TOP_THRESHOLD_REACHED);
            this.setCompareToLast(raw.COMPARE_TO_LAST);
            this.setPayerCountry(raw.PAYER_COUNTRY);
            this.setMeasurementPeriod(raw.MEASUREMENT_PERIOD);
            this.setDiscountPeriod(raw.DISCOUNT_PERIOD);
            this.setCountryEndSeq(raw.COUNTRY_END_SEQ);
            this.setDiscountPid(raw.DISCOUNT_PID);
            this.setDiscountProductGroup(raw.DISCOUNT_PRODUCT_GROUP);
            this.setNonReviewReason(raw.NON_REVIEW_REASON);
            this.setReviewDtm(raw.REVIEW_DTM);
            this.setMeasurementStartDate(raw.MEASUREMENT_START_DATE);
            this.setMeasurementEndDate(raw.MEASUREMENT_END_DATE);
            this.setDiscountStartDate(raw.DISCOUNT_START_DATE);
            this.setDiscountEndDate(raw.DISCOUNT_END_DATE);
            this.setCurrencyCode(raw.CURRENCY_CODE);
        }
    }

    public getCpaKey(): string {
        return this.cpaKey;
    }

    public setCpaKey(cpaKey: string): void {
        this.cpaKey = cpaKey;
    }

    public getReviewDate(): number {
        return this.reviewDate;
    }

    public setReviewDate(reviewDate: number): void {
        this.reviewDate = reviewDate;
    }

    public getDiscountKey(): string {
        return this.discountKey;
    }

    public setDiscountKey(discountKey: string): void {
        this.discountKey = discountKey;
    }

    public getShipmentCount(): number | null {
        return this.shipmentCount;
    }

    public setShipmentCount(shipmentCount: number | null): void {
        this.shipmentCount = shipmentCount;
    }

    public getRevenueCount(): number | null {
        return this.revenueCount;
    }

    public setRevenueCount(revenueCount: number | null): void {
        this.revenueCount = revenueCount;
    }

    public getDiscountAmount(): number | null {
        return this.discountAmount;
    }

    public setDiscountAmount(discountAmount: number | null): void {
        this.discountAmount = discountAmount;
    }

    public getDiscountPercent(): number | null {
        return this.discountPercent;
    }

    public setDiscountPercent(discountPercent: number | null): void {
        this.discountPercent = discountPercent;
    }

    public getTopThresholdReached(): string | null {
        return this.topThresholdReached;
    }

    public setTopThresholdReached(topThresholdReached: string | null): void {
        this.topThresholdReached = topThresholdReached;
    }

    public getCompareToLast(): string | null {
        return this.compareToLast;
    }

    public setCompareToLast(compareToLast: string | null): void {
        this.compareToLast = compareToLast;
    }

    public getPayerCountry(): string {
        return this.payerCountry;
    }

    public setPayerCountry(payerCountry: string): void {
        this.payerCountry = payerCountry;
    }

    public getMeasurementPeriod(): number | null {
        return this.measurementPeriod;
    }

    public setMeasurementPeriod(measurementPeriod: number | null): void {
        this.measurementPeriod = measurementPeriod;
    }

    public getDiscountPeriod(): number | null {
        return this.discountPeriod;
    }

    public setDiscountPeriod(discountPeriod: number | null): void {
        this.discountPeriod = discountPeriod;
    }

    public getCountryEndSeq(): number | null {
        return this.countryEndSeq;
    }

    public setCountryEndSeq(countryEndSeq: number | null): void {
        this.countryEndSeq = countryEndSeq;
    }

    public getDiscountPid(): string | null {
        return this.discountPid;
    }

    public setDiscountPid(discountPid: string | null): void {
        this.discountPid = discountPid;
    }

    public getDiscountProductGroup(): string {
        return this.discountProductGroup;
    }

    public setDiscountProductGroup(discountProductGroup: string): void {
        this.discountProductGroup = discountProductGroup;
    }

    public getNonReviewReason(): string | null {
        return this.nonReviewReason;
    }

    public setNonReviewReason(nonReviewReason: string | null): void {
        this.nonReviewReason = nonReviewReason;
    }

    public getReviewDtm(): number | null {
        return this.reviewDtm;
    }

    public setReviewDtm(reviewDtm: number | null): void {
        this.reviewDtm = reviewDtm;
    }

    public getMeasurementStartDate(): number | null {
        return this.measurementStartDate;
    }

    public setMeasurementStartDate(measurementStartDate: number | null): void {
        this.measurementStartDate = measurementStartDate;
    }

    public getMeasurementEndDate(): number | null {
        return this.measurementEndDate;
    }

    public setMeasurementEndDate(measurementEndDate: number | null): void {
        this.measurementEndDate = measurementEndDate;
    }

    public getDiscountStartDate(): number | null {
        return this.discountStartDate;
    }

    public setDiscountStartDate(discountStartDate: number | null): void {
        this.discountStartDate = discountStartDate;
    }

    public getDiscountEndDate(): number | null {
        return this.discountEndDate;
    }

    public setDiscountEndDate(discountEndDate: number | null): void {
        this.discountEndDate = discountEndDate;
    }

    public getCurrencyCode(): string | null {
        return this.currencyCode;
    }

    public setCurrencyCode(currencyCode: string | null): void {
        this.currencyCode = currencyCode;
    }

}